<template>
         <v-card tile>
            <v-card-title>ข้อมูลการรับอะไหล่</v-card-title>
            <v-divider></v-divider>
            <v-container>
                <v-form ref="form" >
                <v-row>
                    <v-col> <v-text-field disabled outlined v-model="mainData.docDate" label="วันที่ในเอกสาร"></v-text-field></v-col>
                    <v-col><v-text-field disabled outlined v-model="mainData.receiveDate" label="วันที่รับอะไหล่"></v-text-field></v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field disabled outlined v-model="mainData.receiveNo" label="เลขที่ใบรับอะไหล่"></v-text-field>
                    </v-col>
                    <v-col><v-text-field :rules="[rules.required]" v-model="mainData.jobNo" outlined :disabled="!isEdit" autofocus label="เลขที่ใบสั่งซ่อม"></v-text-field></v-col>
                    <v-col><v-text-field v-model="mainData.percentDiscount" outlined disabled label="ส่วนลด"></v-text-field></v-col>
                    <v-col><v-text-field v-model="mainData.receiver" outlined disabled label="ผู้รับ"></v-text-field></v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-data-table
                        :headers="header"
                        :items="mainData.details"
                        style="border:0.2px solid; border-color:#909090"
                        >
                       <template v-slot:top>
                           <v-toolbar flat color="white">
                               <v-toolbar-title>รายการอะไหล่</v-toolbar-title>
                           </v-toolbar>
                       </template>
                            <template v-slot:header.discount>
                                <thead>
                                    <tr>
                                        <th colspan="2" class="indigo--text text-center">ส่วนลด</th>
                                    </tr>
                                    <tr>
                                        <th class="indigo--text text-center">%</th>
                                        <th class="indigo--text text-center">ยอด</th>
                                    </tr>
                                </thead>
                            </template>

                            <template v-slot:item.discount="{item}">
                                <tr>
                                    <th class="text-center">{{item.percentDiscount}}</th>
                                    <th class="text-center">{{item.discount}}</th>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                 <v-row>
                    <v-col cols="8">
                        <v-data-table
                        :headers="headerSummary"
                        :items="itemSummary"
                        style="border:0.2px solid; border-color:#909090"
                        hide-default-footer
                        >
                        </v-data-table>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex align-end align-center">
                        <v-btn v-if="isEdit" style="margin-right:10px;" color="primary"   @click="save">บันทึก</v-btn>&nbsp;
                        <v-btn color="primary"  @click="close">ปิด</v-btn>
                    </v-col>
                </v-row>
                </v-form>
                
            </v-container>
        </v-card>
            
</template>


<style scoped>
    .col-header {
        background: indigo;
        color: indigo;
    }
</style>


<script>
import {getStockParts, updateJobNo} from '@/api/stock/stock-parts-api.js'
import numeral from 'numeral'
export default {
    name: 'ViewParts',
    data: () => ({
        isEdit: false,
        rules: {
            required: value => !!value || 'Required.'
        },
        header: [
            {text: 'NO.', value: 'no', class: 'indigo--text'},
            {text: 'หมายเลขอะไหล่', value: 'partsCode', class: 'indigo--text'},
            {text: 'ชื่อรายการอะไหล่', value: 'partsName', class: 'indigo--text'},
            {text: 'จำนวน', value: 'qty', class: 'indigo--text'},
            {text: 'ราคา/หน่วย', value: 'unitPriceDisplay', class: 'indigo--text'},
            {text: 'ยอดรวม', value: 'amountDisplay', class: 'indigo--text'},
            {text: 'ส่วนลด', value: 'discountDisplay', sortable: false, class: 'indigo--text'},
            {text: 'รวมสุทธิ', value: 'netAmountDisplay', class: 'indigo--text'}
        ],
        headerSummary: [
            {text: '', value: 'sumType'},
            {text: 'ยอดรวม', value: 'amountDisplay'},
            {text: 'ส่วนลด', value: 'discountDisplay'},
            {text: 'ราคารวมสุทธิ', value: 'netDisplay'}
        ],
        itemSummary: [],
        mainData: {
            branchCode: '',
            receiveNo: '',
            docDate: '',
            receiveDate: '',
            jobNo: '',
            percentDiscount: 0,
            receiver: '',
            details: []
        },
        detail: {
                partsCode: '',
                partsName: '',
                warehouse: '',
                unitPrice: 0,
                qty: 1,
                amount: 0,
                netAmount: 0,
                percentDiscount: 0,
                discount: 0,
                remark: '',
        },
        summary: {
            default: {
                amount: 0,
                discount: 0,
                net: 0
            },
            sum: {
                sumType: 'รวม',
                amount: 0,
                discount: 0,
                net: 0
            },
            vat: {
                sumType: 'ภาษี 7%',
                amount: 0,
                discount: 0,
                net: 0
            },
            total: {
                sumType: 'รวมทั้งสิ้น',
                amount: 0,
                discount: 0,
                net: 0
            }
        }
    }),
    methods: {
        close() {
            this.mainData = [];
            this.itemSummary = [];
            this.summary.sum = Object.assign(this.summary.sum, this.summary.default);
            this.summary.vat = Object.assign(this.summary.vat, this.summary.default);
            this.summary.total = Object.assign(this.summary.total, this.summary.default);
            this.$emit("closeViewParts");
        },
        calculateSummary(detail) {
            this.summary.sum.amount += detail.amount;
            this.summary.sum.discount += detail.discount;
            this.summary.sum.net += detail.netAmount;
            this.setDisplaySummary(this.summary.sum);

            this.summary.vat.amount = (this.summary.sum.amount * 7) / 100;
            this.summary.vat.discount = (this.summary.sum.discount * 7) / 100;
            this.summary.vat.net = (this.summary.sum.net * 7) / 100;
            this.setDisplaySummary(this.summary.vat);

            this.summary.total.amount = this.summary.sum.amount + this.summary.vat.amount;
            this.summary.total.discount = this.summary.sum.discount + this.summary.vat.discount;
            this.summary.total.net = this.summary.sum.net + this.summary.vat.net;
            this.setDisplaySummary(this.summary.total);
        },
        setDisplay(obj) {
            obj.unitPriceDisplay = numeral(obj.unitPrice).format('0,0.00');
            obj.amountDisplay = numeral(obj.amount).format('0,0.00');
            obj.discountDisplay = numeral(obj.discount).format('0,0.00');
            obj.netAmountDisplay = numeral(obj.netAmount).format('0,0.00');
        },
        setDisplaySummary(obj) {
            obj.amountDisplay = numeral(obj.amount).format('0,0.00');
            obj.discountDisplay = numeral(obj.discount).format('0,0.00');
            obj.netDisplay = numeral(obj.net).format('0,0.00');
        },
        save() {
            if (!this.$refs.form.validate() || this.mainData.details.length <= 0) {
                return;
            }
            this.$loading(true);
            updateJobNo(this.mainData).then( () => {
                this.$loading(false);
                this.close();
            }).catch( () => {
                this.$loading(false);
            });
        },
        show(id) {
            this.itemSummary = [];
            this.mainData = {};
            getStockParts(id).then(rs => {
                this.mainData = rs;
                this.mainData.receivePartsId = id;
                if (!this.mainData.details) return;

                this.isEdit = this.mainData.jobNo == undefined || this.mainData.jobNo.length == 0;
                this.mainData.details.forEach(detail => {
                    this.setDisplay(detail);
                    this.calculateSummary(detail);
                });

                this.itemSummary.push(this.summary.sum);
                this.itemSummary.push(this.summary.vat);
                this.itemSummary.push(this.summary.total);
            });
        }
    }
}
</script>